import "./App.css";
import "./Fonts.css";
import React from "react";
import Home from "./Screens/Home/Home";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import About from "./Screens/About/About";
import WhySerene from "./Screens/WhySerene/WhySerene";
import TaxPlanning from "./Screens/AllServices/TaxPlanning/TaxPlanning";
import TaxReturns from "./Screens/AllServices/TaxReturns/TaxReturns";
import IRSAudit from "./Screens/AllServices/IRSAudit/IRSAudit";
import ITIN from "./Screens/AllServices/ITIN/ITIN";
import ExtensionService from "./Screens/AllServices/Extension/Extension";
import PayrollService from "./Screens/AllServices/Payroll/Payroll";
import FBARService from "./Screens/AllServices/FBAR/FBAR";
import FatcaService from "./Screens/AllServices/FatcaService/FatcaService";
import AlienService from "./Screens/AllServices/AlienService/AlienService";
import Pricing from "./Screens/Pricing/Pricing";
import ContactUs from "./Screens/ContactUs/ContactUs";
import Signup from "./Screens/Signup/Signup";
import Login from "./Screens/Login/Login";
import FAQ from "./Screens/FAQ/FAQ";
import ClientDashboardHome from "./ClientDashboard/Home/Home";
import NotFound from "./ClientDashboard/NotFound/NotFound";
import ClientDashboardSettings from "./ClientDashboard/Settings/Settings";
import ClientDashboardMessages from "./ClientDashboard/Messages/Messages";
import ClientDashboardReferrals from "./ClientDashboard/Referrals/Referrals";
import ClientDashboardMakePayment from "./ClientDashboard/MakePayment/MakePayment";
import ClientDashboardTaxSummary from "./ClientDashboard/TaxSummary/TaxSummary";
import ClientDashboardUploadDocuments from "./ClientDashboard/UploadDocument/UploadDocument";
import ClientDashboardPersonalInfo from "./ClientDashboard/PersonalInfo/PersonalInfo";
import ClientDashboardDependentInfo from "./ClientDashboard/DependentInfo/DependentInfo";
import ClientDashboardAddDependentInfo from "./ClientDashboard/DependentInfo/AddDependentInfo";
import ClientDashboardAddBankDetails from "./ClientDashboard/BankDetails/BankDetails";
import ClientDashboardFBAR from "./ClientDashboard/FBAR/FBAR";
import ClientDashboardOtherIncome from "./ClientDashboard/OtherIncome/OtherIncome";
import ClientDashboardExpenses from "./ClientDashboard/Expenses/Expenses";
import ClientDashboardAddRentalIncome from "./ClientDashboard/RentalIncome/RentalIncome";
import ClientDashboardWrap from "./ClientDashboard/Components/ClientDashboardWrap/ClientDashboardWrap";
import AdminDashboardWrapper from "./AdminDashboard/Components/AdminDashboardWrapper/AdminDashboardWrapper";
import Scheduling from "./AdminDashboard/Scheduling/Scheduling";
import AssignLeads from "./AdminDashboard/Documents/AssignLeads/AssignLeads";
import All from "./AdminDashboard/Documents/All/All";
import Messages from "./AdminDashboard/Documents/Messages/Messages";
import NewFile from "./AdminDashboard/Documents/NewFile/NewFile";
import DocsPending from "./AdminDashboard/Documents/DocsPending/DocsPending";
import CallBack from "./AdminDashboard/Documents/CallBack/CallBack";
import CallIndia from "./AdminDashboard/Documents/CallIndia/CallIndia";
import DocsReviewed from "./AdminDashboard/Documents/DocsReviewed/DocsReviewed";
import AddDocsPending from "./AdminDashboard/Documents/AddDocsPending/AddDocsPending";
import AddDocsReviewed from "./AdminDashboard/Documents/AddDocsReviewed/AddDocsReviewed";
import PaymentTrying from "./AdminDashboard/Documents/PaymentTrying/PaymentTrying";
import PaymentRecieved from "./AdminDashboard/Documents/PaymentRecieved/PaymentRecieved";
import VoiceMail from "./AdminDashboard/Documents/VoiceMail/VoiceMail";
import NotInterested from "./AdminDashboard/Documents/NotInterested/NotInterested";
import Extension from "./AdminDashboard/Documents/Extension/Extension";
import Amendment from "./AdminDashboard/Documents/Amendment/Amendment";
import Notice from "./AdminDashboard/Documents/Notice/Notice";
import NoticeResolved from "./AdminDashboard/Documents/NoticeResolved/NoticeResolved";
import ITINAdmin from "./AdminDashboard/Documents/ITIN/ITIN";
import SchedulingRoutes from "./routes/AdminRoutes/SchedulingRoutes";
import DocumentsRoutes from "./routes/AdminRoutes/DocumentsRoutes";
import TaxPreparationRoutes from "./routes/AdminRoutes/TaxPreparationRoutes";
import ReviewRoutes from "./routes/AdminRoutes/ReviewRoutes";
import PaymentRoutes from "./routes/AdminRoutes/PaymentRoutes";
import ClientReviewRoutes from "./routes/AdminRoutes/ClientReviewRoutes";
import EFilingRoutes from "./routes/AdminRoutes/EFilingRoutes";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/why-serene" element={<WhySerene />} />
          <Route path="/tax-planning-service" element={<TaxPlanning />} />
          <Route path="/tax-returns-service" element={<TaxReturns />} />
          <Route path="/irs-audit-service" element={<IRSAudit />} />
          <Route path="/itin-service" element={<ITIN />} />
          <Route path="/extension-service" element={<ExtensionService />} />
          <Route path="/payroll-service" element={<PayrollService />} />
          <Route path="/fbar-service" element={<FBARService />} />
          <Route path="/fatca-service" element={<FatcaService />} />
          <Route path="/alien-service" element={<AlienService />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/faq" element={<FAQ />} />

          {/* client dashboard */}
          <Route path="/client-dashboard" element={<ClientDashboardWrap />}>
            <Route path="home" element={<ClientDashboardHome />} />
            <Route
              path="bi-personal-info"
              element={<ClientDashboardPersonalInfo />}
            />
            <Route
              path="bi-dependent-info"
              element={<ClientDashboardDependentInfo />}
            />
            <Route
              path="bi-adddependent-info"
              element={<ClientDashboardAddDependentInfo />}
            />
            <Route
              path="bi-bank-details"
              element={<ClientDashboardAddBankDetails />}
            />
            <Route path="bi-fbar" element={<ClientDashboardFBAR />} />
            <Route
              path="oi-other-income"
              element={<ClientDashboardOtherIncome />}
            />
            <Route path="oi-expenses" element={<ClientDashboardExpenses />} />
            <Route
              path="oi-rental-income"
              element={<ClientDashboardAddRentalIncome />}
            />

            <Route
              path="upload-document"
              element={<ClientDashboardUploadDocuments />}
            />
            <Route path="tax-summary" element={<ClientDashboardTaxSummary />} />
            <Route
              path="make-payments"
              element={<ClientDashboardMakePayment />}
            />
            <Route path="referrals" element={<ClientDashboardReferrals />} />
            <Route path="messages" element={<ClientDashboardMessages />} />
            <Route path="settings" element={<ClientDashboardSettings />} />
          </Route>
          <Route path="/client-dashboard/*" element={<NotFound />} />
          <Route path="/admin-dashboard" element={<AdminDashboardWrapper />}>
            {SchedulingRoutes()}
            {DocumentsRoutes()}
            {TaxPreparationRoutes()}
            {ReviewRoutes()}
            {PaymentRoutes()}
            {ClientReviewRoutes()}
            {EFilingRoutes()}

            {/* Add more nested routes for admin-dashboard as needed */}
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
